import {lazyGet} from "@dp-instant/core";
import {TypesSocial} from "@dp-instant/interfaces";

export const isIOS = () => {
    if (__SOCIAL__ == "fb" && FBInstant) {
        return FBInstant.getPlatform().toUpperCase() === "IOS";
    }
    return false;
};

export const getGameLocaleByCommonLocaleCode = locale => {
    let result = "EN";

    if (locale) {
        result = locale.split("_", 1)[0].toUpperCase();
    }

    return result;
};

export const isHapticAvailable = () => {
    const vibrationManager = lazyGet(TypesSocial.vibrationManager);
    if (vibrationManager) {
        return vibrationManager.supported;
    }
    return false;
};
